export default __webpack_public_path__ + "static/wish-you-were-here-desktop-3f1f2fca9f07f9e637a1c017424d4ae9.webp";